import { render, staticRenderFns } from "./ProductOrgs.vue?vue&type=template&id=75aa1901&"
import script from "./ProductOrgs.vue?vue&type=script&lang=js&"
export * from "./ProductOrgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports